import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductItemALV2Component } from './product-item-al-v2/product-item-al-v2.component';
import { QuantityStepperModule} from 'abs-ngx-library/src/lib/quantity-stepper';
import { AutoReplenishmentALV1Module } from 'abs-ngx-library/src/lib/auto-replenishment-al-v1'
import { ProductCouponModule } from 'abs-ngx-library/src/lib/product-coupon';
import { QuickAddCheckboxService } from 'abs-ngx-library/src/lib/core';


@NgModule({
  declarations: [ProductItemALV2Component],
  exports: [
    ProductItemALV2Component
  ],
  imports: [
    CommonModule,
    QuantityStepperModule,
    AutoReplenishmentALV1Module,
    ProductCouponModule
  ],
  providers: [
    ProductItemALV2Component,
    QuickAddCheckboxService
  ]
})
export class ProductItemALV2Module { }
